import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface InvoiceV2FormCanDeactivate {
  canDeactivateCreateForm(): boolean | Promise<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class InvoiceV2UnsavedGuard implements CanDeactivate<InvoiceV2FormCanDeactivate> {
  canDeactivate(component: InvoiceV2FormCanDeactivate): boolean | Promise<boolean> {
    return component.canDeactivateCreateForm();
  }
}
